import { StrictMode } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { CometChat } from '@cometchat-pro/chat';

import { configureStore } from '@/store';
import { App } from '@/components';

import * as serviceWorker from './serviceWorker';
import reportWebVitals from './reportWebVitals';

const store = configureStore();

const appID = process.env.REACT_APP_COMETCHAT_APP_ID;
const region = process.env.REACT_APP_COMETCHAT_REGION;
const appSetting = new CometChat.AppSettingsBuilder()
  .subscribePresenceForAllUsers()
  .setRegion(region)
  .overrideAdminHost(`${appID}.api-${region}.cc-cluster-2.io/v3`)
  .overrideClientHost(`${appID}.apiclient-${region}.cc-cluster-2.io/v3`)
  .build();
CometChat.init(appID, appSetting).then(
  () => {
    if (CometChat.setSource) {
      CometChat.setSource('ui-kit', 'web', 'reactjs');
    }
  },
  (error) => {
    console.log('Initialization failed with error:', error);
    // Check the reason for error and take appropriate action.
  }
);

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element');

const root = ReactDOM.createRoot(rootElement);
const router = createBrowserRouter([{ path: '*', element: <App /> }]);

root.render(
  //<StrictMode>
  <Provider store={store}>
    <RouterProvider router={router} />
  </Provider>
  //</StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
